import React, { ReactNode } from 'react';
import { DobType } from '../../interfaces/register';

import {
  required,
  requiredNumber,
  requiredUppercase,
  requiredLowercase,
  requiredSpecialCharacter,
  minLength,
  maxLength,
  composeValidators,
  beforeNow,
  yearAfter1900,
  validDay,
  email,
  zipCode,
  exactLengthDigits,
  phone,
} from '../shared/validations';

import { ErrorMessage } from '../shared/interfaces';
import ErrorMessageWithIcon from './ErrorMessageWithIcon';

export const termsRequired = (value: string): ErrorMessage | ReactNode =>
  value || typeof value === 'number' ? undefined : (
    <ErrorMessageWithIcon message="Please agree to terms and conditions to create your account" />
  );

export const emailComposed = composeValidators(required, email);

export const password = composeValidators(
  required,
  requiredNumber,
  requiredUppercase,
  requiredLowercase,
  requiredSpecialCharacter,
  minLength(8),
  maxLength(20)
);

export const nameComposed = composeValidators(required, maxLength(35));

export const phoneNumberComposed = composeValidators(
  required,
  exactLengthDigits(10),
  phone
);

export const zipCodeComposed = composeValidators(required, zipCode);

export const validateDob = (values: DobType): DobType => {
  const errors: {
    dobDay?: ErrorMessage;
    dobMonth?: ErrorMessage;
    dobYear?: ErrorMessage;
  } = {};
  if (values.dobMonth) {
    if (!values.dobDay) errors.dobDay = { id: 'validations.required' };

    if (!values.dobYear || values.dobYear.toString().length < 4)
      errors.dobYear = { id: 'validations.required' };

    if (
      values.dobDay &&
      values.dobMonth &&
      values.dobYear &&
      values.dobYear.toString().length === 4
    ) {
      errors.dobMonth =
        beforeNow(`${values.dobMonth}/${values.dobDay}/${values.dobYear}`) ||
        yearAfter1900(values.dobYear as string);
      if (errors.dobMonth) {
        errors.dobDay = undefined;
        errors.dobYear = undefined;
      } else {
        errors.dobDay = validDay(
          values.dobDay as string,
          values.dobMonth as string,
          values.dobYear as string
        );
      }
    }
  }
  return errors;
};

export const simpleMemoize = (fn) => {
  let lastArg;
  let lastResult;
  return (arg) => {
    if (arg !== lastArg) {
      lastArg = arg;
      lastResult = fn(arg);
    }
    return lastResult;
  };
};
